export const MAIN_CATEGORY_MAP = {
  INTERNET: 'sys:product:internet',
  RENTAL: 'sys:product:rental',
  MVNO: 'sys:product:mvno',
  USIM: 'sys:product:usim',
} as const

export const EXTRA_CATEGORY = {
  PHONE: 'PHONE',
  MOVING: 'MOVING',
  LIFECARE: 'LIFECARE',
  MVNO: 'MVNO',
} as const

export const EARLY_BIRD_EVENT_TYPE = {
  GALAXY_S_26: 'GALAXY_S_26',
} as const

// CRM 접수경로(receivePath) ENUM — body의 `receivePath` 필드에 들어감
// 원본: aj-platform-front/core/common.ts REGIST_TYPE
export const RECEIVE_PATH_MAP = {
  PLATFORM: 'com:regist:path:platform',
  AJUNG: 'com:regist:path:ajung',
  NO_SEARCH_QUOTE: 'com:regist:path:noSearchQuote',
} as const
export type ReceivePathKey = keyof typeof RECEIVE_PATH_MAP
export const RECEIVE_PATH = RECEIVE_PATH_MAP.PLATFORM // 기본값

// CRM 유입경로(inflowPath) ENUM — body의 `inflowPath` 필드에 들어감
// 원본: aj-platform-front/core/product.js INFLOW_PATH_MAP
// **prop으로 받을 때 이 ENUM 값만 허용 (호스트가 자유 문자열 넣으면 서버 500)**
export const INFLOW_PATH_MAP = {
  DIRECT_JOIN: 'sys:regist:inflowPath:directJoin',
  DIRECT_COUNSEL: 'sys:regist:inflowPath:directCounsel',
  DIRECT_RECOMMENDED: 'sys:regist:inflowPath:recommended',
  LANDING: 'sys:regist:inflowPath:landing',
  RENTAL_LANDING: 'sys:regist:inflowPath:rentalLanding',
  COMPANY: 'sys:regist:inflowPath:company',
  NAVER_SEARCH: 'sys:regist:inflowPath:naverSearch',
  CALL_RESERVATION_COUNSEL: 'sys:regist:inflowPath:callReservationCounsel',
  GROWTH: 'sys:regist:inflowPath:growth',
  GROWTH_PROMOTION: 'sys:regist:inflowPath:growthPromotion',
} as const
export type InflowPathKey = keyof typeof INFLOW_PATH_MAP
export const INFLOW_PATH_VALUES = new Set<string>(Object.values(INFLOW_PATH_MAP))
export const NAVER_SEARCH_INFLOW_PATH = INFLOW_PATH_MAP.NAVER_SEARCH

// CRM 약관 구분 코드 (/counsel-request/terms 응답의 type). 테넌트 공통 codeId — sn 과 달리 스키마 간 동일
// 원본: aj-platform-front/core/common.ts TERMS_TYPE_CODE (INT-209)
export const TERMS_TYPE_CODE = {
  /** 이용 약관 */
  NORMAL: 'sys:customer:termsType:normal',
  /** 개인정보 수집-이용 동의 */
  PERSONAL_INFO_USAGE: 'sys:customer:termsType:personalInfoUsage',
  /** 마케팅 수신 동의 */
  MARKETING: 'sys:customer:termsType:marketing',
  /** 개인정보 제3자 제공 동의 */
  THIRD_PARTY_SHARING: 'sys:customer:termsType:thirdPartySharing',
  /** 기타 */
  ETC: 'sys:customer:termsType:etc',
} as const

// CRM 상조타입(레거시 enum) — body의 `sjType` 필드에 들어감 (옵셔널).
// **미전달 시 서버가 결합 상조(COMBINED)로 처리** → 100원 상조 페이지만 'WON_100' 을 지정한다.
// ⚠️ 허용값 외 문자열은 서버가 **400** → prop 을 그대로 믿지 않고 전송 전 검증한다 (INFLOW_PATH 와 동일 방어).
// 단 `sj-code` 가 있는 신규 상품타입 모드에서는 sjType 이 자유 라벨이라 이 화이트리스트를 쓰지 않는다
// (SecretForm.ce.vue 의 buildSjFields 참고).
export const SJ_TYPES = ['WON_100', 'COMBINED'] as const
export const SJ_TYPE_VALUES = new Set<string>(SJ_TYPES)

export const MINUTE = 60 * 1000
